import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const CarouselMainContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    flex-direction: column;
  `}
`;

export const CarouselWrapper = styled.div`
  ${({ theme }) => `
    height: 100%;
    overflow-x: clip;
  `}
`;

export const CarouselInner = styled.div`
  ${({ theme }) => `
    white-space: nowrap;
    transition: transform 0.3s ease-in-out;
  `}
`;

export const CarouselStyledItem = styled.div`
  ${({ theme }) => `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: inherit;
    width: 100%;
    box-sizing: border-box;
    padding: 0 ${cxTheme.spacing[2]};
  `}
`;

export const CarouselButtonWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${cxTheme.spacing[3]};
    gap: ${cxTheme.spacing[1]};
  `}
`;

export const CarouselButton = styled.button<{
  $active: boolean;
}>`
  ${({ theme, $active }) => `
    background-color: ${
      $active ? cxTheme.colors.blue.lighten20 : cxTheme.colors.blue.lighten60
    };
    outline: none;
    border: none;
    border-radius: 50%;
    height: ${cxTheme.spacing[2]};
    width: ${cxTheme.spacing[2]};
    padding: 0;
    cursor: pointer;
    transition: background-color 0.3s ease-out;

    &:hover {
        background-color: ${cxTheme.colors.blue.lighten40};
    }

    &:focus {
        box-shadow: 0 0 0 1px ${cxTheme.colors.green.base};
    }
  `}
`;
